import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import moment from 'moment-mini';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Payment Booking',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/opr/',
      },
      {
        text: 'Payment Booking',
        href: '/adm/opr/payment/booking',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    search: '',
    date_filter: '',
    status_filter: '',
    type_filter: '',
    sortBy: '',
    sortDesc: true,
    fields: [
      {
        key: 'code_paybook',
        label: 'Payment No',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'Book No',
        sortable: true,
      },
      {
        key: 'shipper',
        label: 'Shipper',
        sortable: true,
      },
      {
        key: 'total_final',
        label: 'Total',
        sortable: true,
      },
      {
        key: 'payment_type',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],
    kwitansi_booking: false,
    detail: false,
    form_booking: {
      doc_type: 'Export/Import',
      doc_no: '',
      payment_type: 'payment',
      code_principle: '',
      exchange_rate: 0,
      currency: 'IDR',
      cont_no: '',
      shipper_group: '',
      shipper: '',
      booking_date: '',
      vessel: '',
      destination: '',
      booking_to: '',
      port_of_discharge: '',
      imo_class: '',
      imo_un: '',
      commodity: '',
      pkp: '',
      seal: '',
      ori_party: '',
      paid_party_from: '',
      paid_party_to: '',
      type: '',
      paid_party: [],
      containers: [],
      payment: [],
      total: 0,
      pph23: 0,
      ppn10: 0,
      total_final: 0,
      container_pay: [],
    },
    another_payment: [],
  },
};

export const getters = {
  form_booking(state) {
    return state.data.form_booking;
  },
  kwitansi_booking(state) {
    return state.data.kwitansi_booking;
  },
};

export const mutations = {
  changePayment(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchBooking(context, params) {
    let result = await ApiGetRequest(`opr/booking`, params);
    return !result.error ? result.data.object : [];
  },

  async searchBookingForRefund(context, params) {
    let result = await ApiGetRequest(`opr/payment-booking/refund`, params);
    return !result.error ? result.data.object : [];
  },

  async getListPaymentBooking({ commit, state }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = moment(data.date_filter[0]).format('YYYY-MM-DD');
      params.end_date = moment(data.date_filter[1]).format('YYYY-MM-DD');
    }

    if (data.type_filter && data.type_filter !== '') {
      params.type_filter = data.type_filter;
    }

    let result = await ApiGetRequest(`opr/payment-booking`, params);
    commit('changePayment', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getAnotherPayment({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const result = await ApiPostRequest(
      `opr/payment-booking/get-another-payment`,
      payload
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        another_payment: result.data.object,
      });

      return result.data.object;
    }

    return false;
  },

  async getCalculateBooking({ commit, state }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostRequest(
      `opr/payment-booking/price`,
      payload.form
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        form_booking: {
          ...data.form_booking,
          ...result.data.object,
        },
      });

      return result.data.object;
    }

    return false;
  },

  async getCalculateBookingRefund({ commit, state }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostRequest(
      `opr/payment-booking/price-refund`,
      payload.form
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        form_booking: {
          ...data.form_booking,
          ...result.data.object,
        },
      });

      return result.data.object;
    }

    return false;
  },

  async getDetailPaymentBooking({ commit, state }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/payment-booking/${payload.id}`);
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      let data_result = result.data.object;
      commit('changePayment', {
        form_booking: {
          ...data.form_booking,
          ...data_result,
          id_type_payment: data_result.id_type_payment
            ? data_result.id_type_payment
            : '',
          booking_date: data_result.tgl_paybook
            ? moment(data_result.tgl_paybook).format('DD/MM/YYYY')
            : '',
        },
      });

      return true;
    }

    return false;
  },

  async createPaymentBooking({ commit, state, dispatch }) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/payment-booking`, data.form_booking);
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
        timeout: 1000,
      });
    }

    return result.error ? false : true;
  },

  async updatePaymentBooking({ commit, state, dispatch }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/payment-booking/${payload.id}`,
      data.form_booking
    );
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
        timeout: 1000,
      });
    }

    return result.error ? false : true;
  },

  async deletePaymentBooking({ commit, dispatch }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/payment-booking/${payload.id}`);
    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async getBuktiBayarBooking({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/payment-booking/${payload.id}/kwitansi`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        kwitansi_booking: result.data.object,
      });

      return true;
    }

    return false;
  },

  async getBuktiBayarBookingNotaBaru({ commit }, payload = null) {
    commit('changePayment', {
      loading: true,
    });

    let result = await ApiGetRequest(
      `opr/payment-booking/${payload.id}/kwitansi-new`
    );

    commit('changePayment', {
      loading: false,
    });

    if (!result.error) {
      commit('changePayment', {
        kwitansi_booking: result.data.object,
      });

      return true;
    }

    return false;
  },
};
